import { createFileRoute } from '@tanstack/react-router';

import { PodsumowanieView } from '../../raporty/projekty/PodsumowanieView';

export const Route = createFileRoute('/raporty/podsumowanie-projektow')({
  component: PodsumowanieView,
});
